import SwitchToggle from "../../../components/Atomos/Switch-Toogle/Switch";
import NetworkingMapInfoTooltip from "./NetworkingMapInfoTooltip";
import {
  NETWORKING_CATEGORY_FILTERS,
  type NetworkingCategoryKey,
} from "./networkingMapCategories";

const FILTER_ORDER: NetworkingCategoryKey[] = [
  "jurisdiction",
  "areasOfPractice",
  "additionalOffices",
  "languages",
  "region",
  "previousEvents",
];

const FILTER_BY_KEY = Object.fromEntries(
  NETWORKING_CATEGORY_FILTERS.map((category) => [category.key, category]),
) as Record<NetworkingCategoryKey, (typeof NETWORKING_CATEGORY_FILTERS)[number]>;

const CONNECTION_ATTRIBUTES_TOOLTIP =
  "Personalize your networking experience. Turn on specific connections to reveal your matches based on your active choices.";

type NetworkingMapFiltersProps = {
  selected: NetworkingCategoryKey[];
  onToggle: (category: NetworkingCategoryKey, checked: boolean) => void;
  disabled?: boolean;
  className?: string;
};

export default function NetworkingMapFilters({
  selected,
  onToggle,
  disabled = false,
  className = "",
}: NetworkingMapFiltersProps) {
  return (
    <div className={`flex min-w-0 flex-col gap-3 ${className}`.trim()}>
      <div className="flex items-center gap-2">
        <h2 className="font-['Roboto'] text-base font-semibold leading-normal text-[#474F56]">
          Connection Attributes
        </h2>
        <NetworkingMapInfoTooltip text={CONNECTION_ATTRIBUTES_TOOLTIP} />
      </div>

      <div className="grid min-w-0 grid-cols-1 gap-3 self-stretch rounded-lg sm:grid-cols-2 lg:grid-cols-3 lg:gap-x-4 lg:gap-y-3 xl:gap-x-6">
        {FILTER_ORDER.map((key) => {
          const category = FILTER_BY_KEY[key];
          return (
            <SwitchToggle
              key={category.key}
              title={category.label}
              switchFirst
              small
              blueChecked
              checked={selected.includes(category.key)}
              disabled={disabled}
              seter={(checked) => onToggle(category.key, checked)}
              className="!w-full min-w-0 !justify-start"
              textClass="whitespace-nowrap font-['Roboto'] text-[14px] font-normal leading-5 text-[#474F56]"
            />
          );
        })}
      </div>
    </div>
  );
}
